import { routes } from '../../../config';
import featureFlagService from '../../../services/featureFlagService';
import { setIdpParam } from '../../../utils/authprovider';

const getTaskbarConfig = (addEquipmentCallback, refreshEquipment) => {
  return {
    labels: {
      taskBarTitle:
        'labels.patientRecord.tabs.equipments.taskBar.title',
      summary: {
        switchText:
          'labels.patientRecord.tabs.equipments.all.switch.title',
        taskBarTitle:
          'labels.patientRecord.tabs.equipments.taskBar.summaryTitle',
      },
      allDevices: {
        switchText:
          'labels.patientRecord.tabs.equipments.summary.switch.title',
        taskBarTitle:
          'labels.patientRecord.tabs.equipments.taskBar.title',
      },
    },
    analytics: {
      summary: 'view_all_devices_view_patient',
      allDevices: 'view_summary_devices_view_patient',
    },
    button: {
      onClick: addEquipmentCallback,
      analytics: 'add_empty_devices_view_patient',
    },
    refreshButton: {
      variant: 'tinted',
      icon: 'refresh',
      onClick: refreshEquipment,
      analytics: 'refresh_devices_view_patient',
    },
  };
};

const getToolbarConfig = (
  labels,
  filterSoundProcessor,
  filterAccessories,
  filterImplants,
  resetFilters,
) => {
  return {
    resetDeviceFilters: resetFilters,
    defaultSelection: 'apps',
    items: [
      {
        type: 'breadcrumb',
        icon: '',
        sections: [
          {
            text: labels[
              `labels.patientRecord.tabs.equipments.toolBar.items.show`
            ],
            action: () => {},
          },
        ],
      },
      {
        type: 'filter-button',
        icon: 'apps',
        text: labels[
          `labels.patientRecord.tabs.equipments.toolBar.items.all`
        ],
        onHandle: resetFilters,
        analytics: 'filter_all_devices_view_patient',
      },
      {
        type: 'filter-button',
        icon: 'sound-processor',
        text: labels[
          `labels.patientRecord.tabs.equipments.toolBar.items.soundProcessors`
        ],
        onHandle: filterSoundProcessor,
        analytics: 'filter_soundprocessors_devices_view_patient',
      },
      {
        type: 'filter-button',
        icon: 'accessories',
        text: labels[
          `labels.patientRecord.tabs.equipments.toolBar.items.accessories`
        ],
        onHandle: filterAccessories,
        analytics: 'filter_accessories_devices_view_patient',
      },
      {
        type: 'filter-button',
        icon: 'implant',
        text: labels[
          `labels.patientRecord.tabs.equipments.toolBar.items.implants`
        ],
        onHandle: filterImplants,
        analytics: 'filter_implants_devices_view_patient',
      },
    ],
  };
};

const getDevicesTableConfig = (
  labels,
  patientId,
  displayModalCreateSR,
  fetchExpandedData,
  loadReportIssueModal,
  updateEarSide,
  toggleUpdateAccessoryModal,
  viewServiceRequestForRecipientDevice,
  displayReturnLoanerModal,
) => {
  return {
    tableConfigRight: {
      country: 'US',
      language: 'en',
      formats: {
        date: 'mmm dd yyyy',
        currency: 'USD',
      },
      labels: {
        rowLoading:
          'labels.patientRecord.tabs.serviceRequests.view.loading',
      },
      highlight: false,
      handleSortDataChange: () => {},
      handleExpand: fetchExpandedData,
      columns: [
        {
          display:
            'labels.patientRecord.tabs.equipments.dataTable.columns.blank.header',
          field: 'toggle',
          format: {
            collapsed: {
              type: 'icontoggle',
            },
            expanded: {
              type: 'composite',
              template: `<div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 -8px; width:200%'></div>`,
            },
          },
          sortable: false,
        },

        {
          display:
            'labels.patientRecord.tabs.equipments.dataTable.columns.right.header',
          format: {
            collapsed: {
              type: 'composite',
              template: `
              <div style='display: flex; gap: 0.5rem; align-items: center '>
               <div style='width: 1.5rem; display: flex'>
                  {{#icon}}
                    {{#earLeft}}
                      <span class='ccl__icon ccl__icon--left ccl__icon--color--info ccl__icon--size--sm'></span>
                    {{/earLeft}}
                    {{^earLeft}}
                      <span class='ccl__icon ccl__icon--right ccl__icon--color--warning ccl__icon--size--sm'></span>
                    {{/earLeft}}
                  {{/icon}}
                </div>
                <div>
                  {{#current}}
                    <span class='ccl__text ccl__text--body-text-bold '>{{device.label}}</span>
                  {{/current}}
                  {{^current}}
                    <span class='ccl__text ccl__text--body-text'>{{device.label}}</span>
                  {{/current}}
                </div>
              </div>
              <div style='display: flex; gap: 0.5rem; align-items: center '>
                <div style='width: 1.5rem;'></div>
                {{#loaner}}
                  <div><em id='loaner-label'>{{device.status}}</em></div>
                {{/loaner}}
                {{^loaner}}
                  <div><em>{{device.status}}</em></div>
                {{/loaner}}
              </div>
                `,
            },
            expanded: {
              type: 'composite',
              template: `<div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 0; width:150%;'><ul>
                {{#test.length}}
                  {{#test}}<li>{{.}}</li>{{/test}}
                {{/test.length}}
              <ul></div>`,
            },
          },
          sortable: false,
        },

        {
          // field: 'model',
          display:
            'labels.patientRecord.tabs.equipments.dataTable.columns.device.header',
          format: {
            collapsed: {
              type: 'composite',
              template: `
              {{#current}}
                <div>
                  <span class='ccl__text ccl__text--interactive-text'>{{model.name}}</span>
                </div>
                <div>
                  {{model.info}}
                </div>
              {{/current}}
              {{^current}}
                <div>
                  <span class='ccl__text ccl__text--body-text'>{{model.name}}</span>
                </div>
                <div>
                  {{model.info}}
                </div>
              {{/current}}
              `,
            },
            expanded: {
              type: 'composite',
              template: `
              <div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 0; width:115%; padding: 8px 25px 5px 0'>{{#expandedDataL}}{{#value}}<div style='padding:7px 12px 0 0;'><p class='ccl__text ccl__text--x-small-body-text-bold' style='display:inline'>{{label}}: </p> <p class='ccl__text ccl__text--x-small-body-text' style='display:inline'>{{value}}</p></div>{{/value}}{{/expandedDataL}}</div>
          `,
            },
          },
          sortable: false,
        },

        {
          field: 'warranty',
          display:
            'labels.patientRecord.tabs.equipments.dataTable.columns.warranty.header',
          format: {
            collapsed: {
              type: 'device.warranty',
            },
            expanded: {
              type: 'composite',
              template: `
              <div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 0; width:115%; padding: 8px 0 5px 0'>{{#expandedDataR}}{{#value}}<div style='padding-top:7px'><p class='ccl__text ccl__text--x-small-body-text-bold' style='display:inline'>{{label}}: </p> <p class='ccl__text ccl__text--x-small-body-text' style='display:inline'>{{value}}</p></div>{{/value}}{{/expandedDataR}}</div>
            `,
            },
          },
          sortable: false,
        },

        {
          field: 'view',
          display:
            'labels.patientRecord.tabs.equipments.dataTable.columns.blank.header',
          format: {
            collapsed: {
              type: 'contextMenu',
              items: [
                {
                  name: 'newServiceRequest',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.createServiceRequest`
                  ],
                  onclick(row) {
                    displayModalCreateSR(row?.deviceId, row);
                  },
                },
                {
                  name: 'viewServiceRequest',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.viewServiceRequest`
                  ],
                  onclick(row) {
                    viewServiceRequestForRecipientDevice(row);
                  },
                },
                {
                  name: 'reportAnIssue',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.reportIssue`
                  ],
                  onclick: (row) => {
                    loadReportIssueModal(row);
                  },
                },
                {
                  name: 'print',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.print`
                  ],
                  onclick: () => {
                    // eslint-disable-next-line no-alert
                    alert(
                      labels[
                        `labels.patientRecord.tabs.equipments.dataTable.options.print`
                      ],
                    );
                  },
                },
                {
                  name: 'edit',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.edit`
                  ],
                  onclick: () => {
                    // eslint-disable-next-line no-alert
                    alert(
                      labels[
                        `labels.patientRecord.tabs.equipments.dataTable.options.edit`
                      ],
                    );
                  },
                },
                {
                  name: 'addDevice',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.addDevice`
                  ],
                  onclick: () => {
                    // eslint-disable-next-line no-alert
                    alert(
                      labels[
                        `labels.patientRecord.tabs.equipments.dataTable.options.print`
                      ],
                    );
                  },
                },
                {
                  name: 'remove',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.remove`
                  ],
                  onclick: () => {
                    // eslint-disable-next-line no-alert
                    alert(
                      labels[
                        `labels.patientRecord.tabs.equipments.dataTable.options.remove`
                      ],
                    );
                  },
                },
                {
                  name: 'assignEarLeft',
                  text: labels['labels.common.assignToLeftEar'],
                  onclick: (row) => {
                    updateEarSide('Left', row?.assetId);
                  },
                },
                {
                  name: 'viewServiceRequestForRecipientDevice',
                  text: labels[
                    'labels.patientRecord.tabs.equipments.dataTable.options.viewServiceRequestForRecipientDevice'
                  ],
                  onclick: (row) => {
                    viewServiceRequestForRecipientDevice(row);
                  },
                },
                {
                  name: 'returnLoaner',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.returnLoaner`
                  ],
                  onclick: (row) => {
                    displayReturnLoanerModal(row);
                  },
                },
              ],
              variant: 'tinted',
            },
            expanded: {
              type: 'composite',
              template: `<div style='border-top: 1px solid #cfcfd0; margin: -14px -20% 0 0;'></div>`,
            },
          },
          hiddenColumnLabel: true,
          sortable: false,
          restrictWidth: true, // restrict this cell from growing beyond the bounds of required cell content
        },
      ],
    },
    tableConfigLeft: {
      country: 'US',
      language: 'en',
      formats: {
        date: 'mmm dd yyyy',
        currency: 'USD',
      },
      labels: {
        rowLoading:
          'labels.patientRecord.tabs.serviceRequests.view.loading',
      },
      highlight: false,
      handleSortDataChange: () => {},
      handleExpand: fetchExpandedData,
      columns: [
        {
          display:
            'labels.patientRecord.tabs.equipments.dataTable.columns.blank.header',
          field: 'toggle',
          format: {
            collapsed: {
              type: 'icontoggle',
            },
            expanded: {
              type: 'composite',
              template: `<div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 -8px; width:200%'></div>`,
            },
          },
          sortable: false,
        },

        {
          display:
            'labels.patientRecord.tabs.equipments.dataTable.columns.left.header',
          format: {
            collapsed: {
              type: 'composite',
              template: `
              <div style='display: flex; gap: 0.5rem; align-items: center '>
               <div style='width: 1.5rem; display: flex'>
                  {{#icon}}
                    {{#earLeft}}
                      <span class='ccl__icon ccl__icon--left ccl__icon--color--info ccl__icon--size--sm'></span>
                    {{/earLeft}}
                    {{^earLeft}}
                      <span class='ccl__icon ccl__icon--right ccl__icon--color--warning ccl__icon--size--sm'></span>
                    {{/earLeft}}
                  {{/icon}}
                </div>
                <div>
                  {{#current}}
                    <span class='ccl__text ccl__text--body-text-bold '>{{device.label}}</span>
                  {{/current}}
                  {{^current}}
                    <span class='ccl__text ccl__text--body-text'>{{device.label}}</span>
                  {{/current}}
                </div>
              </div>
              <div style='display: flex; gap: 0.5rem; align-items: center '>
                <div style='width: 1.5rem;'></div>
                {{#loaner}}
                  <div><em id='loaner-label'>{{device.status}}</em></div>
                {{/loaner}}
                {{^loaner}}
                  <div><em>{{device.status}}</em></div>
                {{/loaner}}
              </div>
                `,
            },
            expanded: {
              type: 'composite',
              template: `<div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 0; width:150%;'><ul>
                {{#test.length}}
                  {{#test}}<li>{{.}}</li>{{/test}}
                {{/test.length}}
              <ul></div>`,
            },
          },
          sortable: false,
        },

        {
          // field: 'model',
          display:
            'labels.patientRecord.tabs.equipments.dataTable.columns.device.header',
          format: {
            collapsed: {
              type: 'composite',
              template: `
              {{#current}}
                <div>
                  <span class='ccl__text ccl__text--interactive-text'>{{model.name}}</span>
                </div>
                <div>
                  {{model.info}}
                </div>
              {{/current}}
              {{^current}}
                <div>
                  <span class='ccl__text ccl__text--body-text'>{{model.name}}</span>
                </div>
                <div>
                  {{model.info}}
                </div>
              {{/current}}
              `,
            },
            expanded: {
              type: 'composite',
              template: `
              <div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 0; width:115%; padding: 8px 25px 5px 0'>{{#expandedDataL}}{{#value}}<div style='padding:7px 12px 0 0;'><p class='ccl__text ccl__text--x-small-body-text-bold' style='display:inline'>{{label}}: </p> <p class='ccl__text ccl__text--x-small-body-text' style='display:inline'>{{value}}</p></div>{{/value}}{{/expandedDataL}}</div>
          `,
            },
          },
          sortable: false,
        },

        {
          field: 'warranty',
          display:
            'labels.patientRecord.tabs.equipments.dataTable.columns.warranty.header',
          format: {
            collapsed: {
              type: 'device.warranty',
            },
            expanded: {
              type: 'composite',
              template: `
              <div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 0; width:115%; padding: 8px 0 5px 0'>{{#expandedDataR}}{{#value}}<div style='padding-top:7px'><p class='ccl__text ccl__text--x-small-body-text-bold' style='display:inline'>{{label}}: </p> <p class='ccl__text ccl__text--x-small-body-text' style='display:inline'>{{value}}</p></div>{{/value}}{{/expandedDataR}}</div>
            `,
            },
          },
          sortable: false,
        },

        {
          field: 'view',
          display:
            'labels.patientRecord.tabs.equipments.dataTable.columns.blank.header',
          format: {
            collapsed: {
              type: 'contextMenu',
              items: [
                {
                  name: 'newServiceRequest',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.createServiceRequest`
                  ],
                  onclick(row) {
                    displayModalCreateSR(row?.deviceId, row);
                  },
                },
                {
                  name: 'viewServiceRequest',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.viewServiceRequest`
                  ],
                  onclick(row) {
                    viewServiceRequestForRecipientDevice(row);
                  },
                },
                {
                  name: 'reportAnIssue',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.reportIssue`
                  ],
                  onclick: (row) => {
                    loadReportIssueModal(row);
                  },
                },
                {
                  name: 'print',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.print`
                  ],
                  onclick: () => {
                    // eslint-disable-next-line no-alert
                    alert(
                      labels[
                        `labels.patientRecord.tabs.equipments.dataTable.options.print`
                      ],
                    );
                  },
                },
                {
                  name: 'edit',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.edit`
                  ],
                  onclick: () => {
                    // eslint-disable-next-line no-alert
                    alert(
                      labels[
                        `labels.patientRecord.tabs.equipments.dataTable.options.edit`
                      ],
                    );
                  },
                },
                {
                  name: 'addDevice',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.addDevice`
                  ],
                  onclick: () => {
                    // eslint-disable-next-line no-alert
                    alert(
                      labels[
                        `labels.patientRecord.tabs.equipments.dataTable.options.print`
                      ],
                    );
                  },
                },
                {
                  name: 'remove',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.remove`
                  ],
                  onclick: () => {
                    // eslint-disable-next-line no-alert
                    alert(
                      labels[
                        `labels.patientRecord.tabs.equipments.dataTable.options.remove`
                      ],
                    );
                  },
                },
                {
                  name: 'assignEarRight',
                  text: labels['labels.common.assignToRightEar'],
                  onclick: (row) => {
                    updateEarSide('Right', row?.assetId);
                  },
                },
                {
                  name: 'viewServiceRequestForRecipientDevice',
                  text: labels[
                    'labels.patientRecord.tabs.equipments.dataTable.options.viewServiceRequestForRecipientDevice'
                  ],
                  onclick: (row) => {
                    viewServiceRequestForRecipientDevice(row);
                  },
                },
                {
                  name: 'returnLoaner',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.returnLoaner`
                  ],
                  onclick: (row) => {
                    displayReturnLoanerModal(row);
                  },
                },
              ],
              variant: 'tinted',
            },
            expanded: {
              type: 'composite',
              template: `<div style='border-top: 1px solid #cfcfd0; margin: -14px -20% 0 0;'></div>`,
            },
          },
          hiddenColumnLabel: true,
          sortable: false,
          restrictWidth: true, // restrict this cell from growing beyond the bounds of required cell content
        },
      ],
    },
    tableConfigUnknown: {
      country: 'US',
      language: 'en',
      formats: {
        date: 'mmm dd yyyy',
        currency: 'USD',
      },
      labels: {
        rowLoading:
          'labels.patientRecord.tabs.serviceRequests.view.loading',
      },
      highlight: false,
      handleSortDataChange: () => {},
      handleExpand: fetchExpandedData,
      columns: [
        {
          display:
            'labels.patientRecord.tabs.equipments.dataTable.columns.blank.header',
          field: 'toggle',
          format: {
            collapsed: {
              type: 'icontoggle',
            },
            expanded: {
              type: 'composite',
              template: `<div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 -8px; width:200%'></div>`,
            },
          },
          sortable: false,
        },

        {
          display:
            'labels.patientRecord.tabs.equipments.dataTable.columns.unknown.header',
          format: {
            collapsed: {
              type: 'composite',
              template: `
              <div style='display: flex; gap: 0.5rem; align-items: center '>
               <div style='width: 1.5rem; display: flex'>
                  {{#icon}}
                    {{#earLeft}}
                      <span class='ccl__icon ccl__icon--left ccl__icon--color--info ccl__icon--size--sm'></span>
                    {{/earLeft}}
                    {{^earLeft}}
                      <span class='ccl__icon ccl__icon--right ccl__icon--color--warning ccl__icon--size--sm'></span>
                    {{/earLeft}}
                  {{/icon}}
                </div>
                <div>
                  {{#current}}
                    <span class='ccl__text ccl__text--body-text-bold '>{{device.label}}</span>
                  {{/current}}
                  {{^current}}
                    <span class='ccl__text ccl__text--body-text'>{{device.label}}</span>
                  {{/current}}
                </div>
              </div>
              <div style='display: flex; gap: 0.5rem; align-items: center '>
                <div style='width: 1.5rem;'></div>
                {{#loaner}}
                  <div><em id='loaner-label'>{{device.status}}</em></div>
                {{/loaner}}
                {{^loaner}}
                  <div><em>{{device.status}}</em></div>
                {{/loaner}}
              </div>
                `,
            },
            expanded: {
              type: 'composite',
              template: `<div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 0; width:150%;'><ul>
                {{#test.length}}
                  {{#test}}<li>{{.}}</li>{{/test}}
                {{/test.length}}
              <ul></div>`,
            },
          },
          sortable: false,
        },

        {
          // field: 'model',
          display:
            'labels.patientRecord.tabs.equipments.dataTable.columns.device.header',
          format: {
            collapsed: {
              type: 'composite',
              template: `
              {{#current}}
                <div>
                  <span class='ccl__text ccl__text--interactive-text'>{{model.name}}</span>
                </div>
                <div>
                  {{model.info}}
                </div>
              {{/current}}
              {{^current}}
                <div>
                  <span class='ccl__text ccl__text--body-text'>{{model.name}}</span>
                </div>
                <div>
                  {{model.info}}
                </div>
              {{/current}}
              `,
            },
            expanded: {
              type: 'composite',
              template: `
              <div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 0; width:115%; padding: 8px 25px 5px 0'>{{#expandedDataL}}{{#value}}<div style='padding:7px 12px 0 0;'><p class='ccl__text ccl__text--x-small-body-text-bold' style='display:inline'>{{label}}: </p> <p class='ccl__text ccl__text--x-small-body-text' style='display:inline'>{{value}}</p></div>{{/value}}{{/expandedDataL}}</div>
          `,
            },
          },
          sortable: false,
        },

        {
          field: 'warranty',
          display:
            'labels.patientRecord.tabs.equipments.dataTable.columns.warranty.header',
          format: {
            collapsed: {
              type: 'device.warranty',
            },
            expanded: {
              type: 'composite',
              template: `
              <div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 0; width:115%; padding: 8px 0 5px 0'>{{#expandedDataR}}{{#value}}<div style='padding-top:7px'><p class='ccl__text ccl__text--x-small-body-text-bold' style='display:inline'>{{label}}: </p> <p class='ccl__text ccl__text--x-small-body-text' style='display:inline'>{{value}}</p></div>{{/value}}{{/expandedDataR}}</div>
            `,
            },
          },
          sortable: false,
        },

        {
          field: 'view',
          display:
            'labels.patientRecord.tabs.equipments.dataTable.columns.blank.header',
          format: {
            collapsed: {
              type: 'contextMenu',
              items: [
                {
                  name: 'newServiceRequest',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.createServiceRequest`
                  ],
                  onclick(row) {
                    displayModalCreateSR(row?.deviceId, row);
                  },
                },
                {
                  name: 'viewServiceRequest',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.viewServiceRequest`
                  ],
                  onclick(row) {
                    viewServiceRequestForRecipientDevice(row);
                  },
                },
                {
                  name: 'reportAnIssue',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.reportIssue`
                  ],
                  onclick: (row) => {
                    loadReportIssueModal(row);
                  },
                },
                {
                  name: 'print',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.print`
                  ],
                  onclick: () => {
                    // eslint-disable-next-line no-alert
                    alert(
                      labels[
                        `labels.patientRecord.tabs.equipments.dataTable.options.print`
                      ],
                    );
                  },
                },
                {
                  name: 'edit',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.edit`
                  ],
                  onclick: () => {
                    // eslint-disable-next-line no-alert
                    alert(
                      labels[
                        `labels.patientRecord.tabs.equipments.dataTable.options.edit`
                      ],
                    );
                  },
                },
                {
                  name: 'addDevice',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.addDevice`
                  ],
                  onclick: () => {
                    // eslint-disable-next-line no-alert
                    alert(
                      labels[
                        `labels.patientRecord.tabs.equipments.dataTable.options.print`
                      ],
                    );
                  },
                },
                {
                  name: 'remove',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.remove`
                  ],
                  onclick: () => {
                    // eslint-disable-next-line no-alert
                    alert(
                      labels[
                        `labels.patientRecord.tabs.equipments.dataTable.options.remove`
                      ],
                    );
                  },
                },
                {
                  name: 'assignEarLeft',
                  text: labels['labels.common.assignToLeftEar'],
                  onclick: (row) => {
                    updateEarSide('Left', row?.assetId);
                  },
                },
                {
                  name: 'assignEarRight',
                  text: labels['labels.common.assignToRightEar'],
                  onclick: (row) => {
                    updateEarSide('Right', row?.assetId);
                  },
                },
                {
                  name: 'viewServiceRequestForRecipientDevice',
                  text: labels[
                    'labels.patientRecord.tabs.equipments.dataTable.options.viewServiceRequestForRecipientDevice'
                  ],
                  onclick: (row) => {
                    viewServiceRequestForRecipientDevice(row);
                  },
                },
                {
                  name: 'returnLoaner',
                  text: labels[
                    `labels.patientRecord.tabs.equipments.dataTable.options.returnLoaner`
                  ],
                  onclick: (row) => {
                    displayReturnLoanerModal(row);
                  },
                },
              ],
              variant: 'tinted',
            },
            expanded: {
              type: 'composite',
              template: `<div style='border-top: 1px solid #cfcfd0; margin: -14px -20% 0 0;'></div>`,
            },
          },
          hiddenColumnLabel: true,
          sortable: false,
          restrictWidth: true, // restrict this cell from growing beyond the bounds of required cell content
        },
      ],
    },
    country: 'US',
    language: 'en',
    formats: {
      date: 'mmm dd yyyy',
      currency: 'USD',
    },
    labels: {
      rowLoading:
        'labels.patientRecord.tabs.serviceRequests.view.loading',
    },
    highlight: false,
    handleSortDataChange: () => {},
    handleExpand: fetchExpandedData,
    columns: [
      {
        display:
          'labels.patientRecord.tabs.equipments.dataTable.columns.blank.header',
        field: 'toggle',
        format: {
          collapsed: {
            type: 'icontoggle',
          },
          expanded: {
            type: 'composite',
            template: `<div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 -8px; width:200%'></div>`,
          },
        },
        sortable: false,
      },

      {
        display:
          'labels.patientRecord.tabs.equipments.dataTable.columns.device.header',
        format: {
          collapsed: {
            type: 'composite',
            template: `
            <div style='display: flex; gap: 0.5rem; align-items: center '>
             <div style='width: 1.5rem; display: flex'>
                {{#icon}}
                  {{#earLeft}}
                    <span class='ccl__icon ccl__icon--left ccl__icon--color--info ccl__icon--size--sm'></span>
                  {{/earLeft}}
                  {{^earLeft}}
                    <span class='ccl__icon ccl__icon--right ccl__icon--color--warning ccl__icon--size--sm'></span>
                  {{/earLeft}}
                {{/icon}}
              </div>
              <div>
                {{#current}}
                  <span class='ccl__text ccl__text--body-text-bold '>{{device.label}}</span>
                {{/current}}
                {{^current}}
                  <span class='ccl__text ccl__text--body-text'>{{device.label}}</span>
                {{/current}}
              </div>
            </div>
            <div style='display: flex; gap: 0.5rem; align-items: center '>
              <div style='width: 1.5rem;'></div>
              {{#loaner}}
                <div><em id='loaner-label'>{{device.status}}</em></div>
              {{/loaner}}
              {{^loaner}}
                <div><em>{{device.status}}</em></div>
              {{/loaner}}
            </div>
              `,
          },
          expanded: {
            type: 'composite',
            template: `<div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 0; width:150%;'><ul>
              {{#test.length}}
                {{#test}}<li>{{.}}</li>{{/test}}
              {{/test.length}}
            <ul></div>`,
          },
        },
        sortable: false,
      },

      {
        // field: 'model',
        display:
          'labels.patientRecord.tabs.equipments.dataTable.columns.model.header',
        format: {
          collapsed: {
            type: 'composite',
            template: `
            {{#current}}
              <div>
                <span class='ccl__text ccl__text--interactive-text'>{{model.name}}</span>
              </div>
              <div>
                {{model.info}}
              </div>
            {{/current}}
            {{^current}}
              <div>
                <span class='ccl__text ccl__text--body-text'>{{model.name}}</span>
              </div>
              <div>
                {{model.info}}
              </div>
            {{/current}}
            `,
          },
          expanded: {
            type: 'composite',
            template: `
            <div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 0; width:115%; padding: 8px 25px 5px 0'>{{#expandedDataL}}{{#value}}<div style='padding:7px 12px 0 0;'><p class='ccl__text ccl__text--x-small-body-text-bold' style='display:inline'>{{label}}: </p> <p class='ccl__text ccl__text--x-small-body-text' style='display:inline'>{{value}}</p></div>{{/value}}{{/expandedDataL}}</div>
        `,
          },
        },
        sortable: false,
      },

      {
        field: 'warranty',
        display:
          'labels.patientRecord.tabs.equipments.dataTable.columns.warranty.header',
        format: {
          collapsed: {
            type: 'device.warranty',
          },
          expanded: {
            type: 'composite',
            template: `
            <div style='border-top: 1px solid #cfcfd0; margin: -14px 0 0 0; width:115%; padding: 8px 0 5px 0'>{{#expandedDataR}}{{#value}}<div style='padding-top:7px'><p class='ccl__text ccl__text--x-small-body-text-bold' style='display:inline'>{{label}}: </p> <p class='ccl__text ccl__text--x-small-body-text' style='display:inline'>{{value}}</p></div>{{/value}}{{/expandedDataR}}</div>
          `,
          },
        },
        sortable: false,
      },

      {
        field: 'view',
        display:
          'labels.patientRecord.tabs.equipments.dataTable.columns.blank.header',
        format: {
          collapsed: {
            type: 'contextMenu',
            items: [
              {
                name: 'newServiceRequest',
                text: labels[
                  `labels.patientRecord.tabs.equipments.dataTable.options.createServiceRequest`
                ],
                onclick(row) {
                  displayModalCreateSR(row?.deviceId, row);
                },
              },
              {
                name: 'viewServiceRequest',
                text: labels[
                  `labels.patientRecord.tabs.equipments.dataTable.options.viewServiceRequest`
                ],
                onclick(row) {
                  viewServiceRequestForRecipientDevice(row);
                },
              },
              {
                name: 'reportAnIssue',
                text: labels[
                  `labels.patientRecord.tabs.equipments.dataTable.options.reportIssue`
                ],
                onclick: (row) => {
                  loadReportIssueModal(row);
                },
              },
              {
                name: 'print',
                text: labels[
                  `labels.patientRecord.tabs.equipments.dataTable.options.print`
                ],
                onclick: () => {
                  // eslint-disable-next-line no-alert
                  alert(
                    labels[
                      `labels.patientRecord.tabs.equipments.dataTable.options.print`
                    ],
                  );
                },
              },
              {
                name: 'edit',
                text: labels[
                  `labels.patientRecord.tabs.equipments.dataTable.options.edit`
                ],
                onclick: () => {
                  // eslint-disable-next-line no-alert
                  alert(
                    labels[
                      `labels.patientRecord.tabs.equipments.dataTable.options.edit`
                    ],
                  );
                },
              },
              {
                name: 'addDevice',
                text: labels[
                  `labels.patientRecord.tabs.equipments.dataTable.options.addDevice`
                ],
                onclick: () => {
                  // eslint-disable-next-line no-alert
                  alert(
                    labels[
                      `labels.patientRecord.tabs.equipments.dataTable.options.print`
                    ],
                  );
                },
              },
              {
                name: 'remove',
                text: labels[
                  `labels.patientRecord.tabs.equipments.dataTable.options.remove`
                ],
                onclick: () => {
                  // eslint-disable-next-line no-alert
                  alert(
                    labels[
                      `labels.patientRecord.tabs.equipments.dataTable.options.remove`
                    ],
                  );
                },
              },
              {
                name: 'assignEarLeft',
                text: labels['labels.common.assignToLeftEar'],
                onclick: (row) => {
                  updateEarSide('Left', row?.assetId);
                },
              },
              {
                name: 'assignEarRight',
                text: labels['labels.common.assignToRightEar'],
                onclick: (row) => {
                  updateEarSide('Right', row?.assetId);
                },
              },
              {
                name: 'replaceAccessory',
                text: labels[
                  'labels.patientRecord.tabs.equipments.dataTable.options.replaceAccessory'
                ],
                onclick: (row) => {
                  toggleUpdateAccessoryModal(true, row);
                },
              },
              {
                name: 'viewServiceRequestForRecipientDevice',
                text: labels[
                  'labels.patientRecord.tabs.equipments.dataTable.options.viewServiceRequestForRecipientDevice'
                ],
                onclick: (row) => {
                  viewServiceRequestForRecipientDevice(row);
                },
              },
              {
                name: 'returnLoaner',
                text: labels[
                  `labels.patientRecord.tabs.equipments.dataTable.options.returnLoaner`
                ],
                onclick: (row) => {
                  displayReturnLoanerModal(row);
                },
              },
            ],
            variant: 'tinted',
          },
          expanded: {
            type: 'composite',
            template: `<div style='border-top: 1px solid #cfcfd0; margin: -14px -20% 0 0;'></div>`,
          },
        },
        hiddenColumnLabel: true,
        sortable: false,
        restrictWidth: true, // restrict this cell from growing beyond the bounds of required cell content
      },
    ],
  };
};

const getEmptyEquipmentConfig = (addEquipementCallback) => {
  return {
    isEmpty: true,
    isLoading: false,
    button: {
      onClick: addEquipementCallback,
      analytics: 'add_empty_devices_view_patient',
    },
  };
};

export const getRightPanelConfig = (
  labels,
  selectedRecipientCId,
  patientId,
  displayModalCreateSR,
  fetchExpandedData,
  addEquipmentCallback,
  filterSoundProcessor,
  filterAccessories,
  filterImplants,
  resetFilters,
  loadReportIssueModal,
  updateEarSide,
  toggleUpdateAccessoryModal,
  refreshEquipment,
  viewServiceRequestForRecipientDevice,
  displayReturnLoanerModal,
) => {
  const featureFlags = featureFlagService.getFeatureFlags();
  const tableConfig = getDevicesTableConfig(
    labels,
    patientId,
    displayModalCreateSR,
    fetchExpandedData,
    loadReportIssueModal,
    updateEarSide,
    toggleUpdateAccessoryModal,
    viewServiceRequestForRecipientDevice,
    displayReturnLoanerModal,
  );
  const toolbarConfig = getToolbarConfig(
    labels,
    filterSoundProcessor,
    filterAccessories,
    filterImplants,
    resetFilters,
  );
  const taskBarConfig = getTaskbarConfig(
    addEquipmentCallback,
    refreshEquipment,
  );
  const emptyEquipment = getEmptyEquipmentConfig(
    addEquipmentCallback,
  );
  return {
    labels: {
      equipment: 'labels.patientRecord.tabs.equipments.title',
      serviceRequests:
        'labels.patientRecord.tabs.serviceRequests.title',
      remoteCheck: 'labels.patientRecord.tabs.remoteCheck.title',
      loadingEquipment:
        'labels.patientRecord.tabs.equipments.loading',
      addDevice: 'labels.patientRecord.tabs.equipments.addDevice',
      emptyEquipment: 'labels.patientRecord.tabs.equipments.empty',
      loading:
        'labels.patientRecord.tabs.serviceRequests.view.loading',
      serviceRequestsNotApplicable:
        'labels.patientRecord.tabs.serviceRequests.view.notApplicable',
    },
    errorConfig: {
      buttons: [],
      imgAlt: 'labels.errorMessage.imgAlt',
      imgSrc:
        'https://mss-p-007-delivery.sitecorecontenthub.cloud/api/public/content/9bfd65ed69994fa49be3ff1339ea9674?v=cc7c6ec3',
      imgWidth: 116,
      layout: 'horizontal',
      text: 'labels.error.text',
      title: 'labels.error.title',
    },
    notFoundErrorConfig: {
      buttons: [],
      imgAlt: 'labels.errorMessage.imgAlt',
      imgSrc:
        'https://mss-p-007-delivery.stylelabs.cloud/api/public/content/66c25eb795cd471a8e7e1dc06c32408a?v=1ccadacd',
      imgWidth: 116,
      layout: 'horizontal',
      text: 'labels.error.checkUrl',
      title: 'labels.error.404',
      code: 404,
    },
    serviceRequestConfig: {
      enabled: featureFlags.serviceRequest,
      serviceRequestUrl: setIdpParam(
        `${routes.mcp.servieRequest}${selectedRecipientCId}`,
      ),
      notApplicable: false,
      hasError: false,
      isLoading: true,
      errorConfig: {
        buttons: [],
        imgAlt: 'labels.errorMessage.imgAlt',
        imgSrc:
          'https://mss-p-007-delivery.sitecorecontenthub.cloud/api/public/content/9bfd65ed69994fa49be3ff1339ea9674?v=cc7c6ec3',
        imgWidth: 116,
        layout: 'horizontal',
        text: 'labels.patientRecord.tabs.serviceRequests.error.text',
        title:
          'labels.patientRecord.tabs.serviceRequests.error.title',
      },
    },
    remoteCheckConfig: {
      enabled: featureFlags.remoteCheck,
      scheduleRemoteCheckScriptPath:
        routes.scheduleRemoteCheckScriptPath,
    },

    tableConfig,
    toolbarConfig,
    taskBarConfig,
    emptyEquipment,
  };
};
